import React, { useEffect } from 'react';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import Icon from 'screens/shared/icon';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import { _t, setKey } from 'utils';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';

export default ({ history = {} }) => {
  const { [ACTIONS_TYPES.CONTRACT.GET_ALL]: contracts = [] } = useSelector((e) => e);

  const onContractClick = (contractNumber) => {
    setKey('selectedContractId', contractNumber);
    history.push('/data-centers');
  };

  useEffect(() => {
    actions.contract.getAll();
    actions.common.setLayoutTitle({ layout: { title: _t('Select a Contract'), menu: ROUTE.DASHBOARD.DATA_CENTERS.key } });
  }, []);

  return (
    <>
      <List>
        {contracts.filter(({ properties = {} }) => properties.status === 'BILLABLE').map(({ properties = {} }) => (
          <ListItem
            button
            onClick={() => onContractClick(properties.contractNumber)}
            key={properties.contractNumber}
          >
            <ListItemAvatar>
              <Avatar>
                <Icon name="person" type="material" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={`${properties.contractNumber} - ${properties.owner}`} />
          </ListItem>
        ))}
      </List>
    </>
  );
};
